declare global {
    interface Window {
        dataLayer?: unknown[]
    }
}

let injected = false

export const loadGtm = (gtmId: string): void => {
    if (!gtmId || injected || typeof document === 'undefined') {
        return
    }

    injected = true

    window.dataLayer = window.dataLayer ?? []
    window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' })

    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`
    document.head.appendChild(script)
}
